import { render, staticRenderFns } from "./AlertCard.vue?vue&type=template&id=2c203c8c&scoped=true"
import script from "./AlertCard.vue?vue&type=script&lang=js"
export * from "./AlertCard.vue?vue&type=script&lang=js"
import style0 from "../css/utilities/scoped/alertCard.css?vue&type=style&index=0&id=2c203c8c&scoped=true&lang=css&external"
import style1 from "../css/utilities/alertCard.css?vue&type=style&index=1&lang=css&external"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c203c8c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2c203c8c')) {
      api.createRecord('2c203c8c', component.options)
    } else {
      api.reload('2c203c8c', component.options)
    }
    module.hot.accept("./AlertCard.vue?vue&type=template&id=2c203c8c&scoped=true", function () {
      api.rerender('2c203c8c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/AlertCard.vue"
export default component.exports